import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import React from 'react'
import { CLOSED_DROPFF_REQUIREMENT_MESSAGE } from '../../util/leadDropoffValidation'

interface MissingDropoffDialogProps {
  open: boolean
  onClose: () => void
}

const MissingDropoffDialog: React.FC<MissingDropoffDialogProps> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Truck Dropoff Required</DialogTitle>
    <DialogContent>
      <Box sx={{ mt: 1 }}>
        <Typography variant="body1">{CLOSED_DROPFF_REQUIREMENT_MESSAGE}</Typography>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="contained" autoFocus>
        OK
      </Button>
    </DialogActions>
  </Dialog>
)

export default MissingDropoffDialog
